export default "__VITE_ASSET__Df1NFpAI__"